import axios from 'axios'

/**
 * @desc Fetch saved retailer IDs for a supplier
 */
export const getSavedRetailers = (supplierId) =>
  axios
    .get(`/authenticated/supplier-retailer-range/${supplierId}`)
    .then((res) => res.data.retailerIds)

/**
 * @desc Create a saved retailer list
 */
export const createSavedRetailers = ({ supplierId, retailerIds }) =>
  axios
    .post(`/authenticated/supplier-retailer-range`, {
      supplierId,
      retailerIds
    })
    .then((res) => res.data.retailerIds)

/**
 * @desc Update a saved retailer list
 */
export const updateSavedRetailers = (supplierId, retailerIds) =>
  axios
    .put(`/authenticated/supplier-retailer-range/${supplierId}`, {
      retailerIds
    })
    .then((res) => res.data.retailerIds)

/**
 * @desc Create or update retailer list based on isNew flag
 */
export const saveRetailerList = ({ supplierId, retailerIds, isNew }) =>
  isNew
    ? createSavedRetailers({ supplierId, retailerIds })
    : updateSavedRetailers(supplierId, retailerIds)
